import { Select } from '../Select'
import { TGroupedRoles, TUserRolesFilterComponent } from './types'
import { useMemo } from 'react'
import './styles.scss'
import { ROLES_BY_GROUPS } from './constants'
import { ALL_ROLES_OPTION, ROLES_NAMES } from '../../constants'
import { ROLES } from '../../features/Permission'
import { TOption } from '../Select/types'

export const UserRolesFilterComponent = ({
  roles,
  onChange,
  groupRoles = true
}: TUserRolesFilterComponent) => {
  const selectOptions = useMemo(() => {
    if (!groupRoles) {
      return [
        ALL_ROLES_OPTION,
        ...roles.map((role) => ({
          ...role,
          label: ROLES_NAMES[role.value] ?? ROLES_NAMES[ROLES.VICE_PRESIDENT]
        }))
      ] as TOption[]
    }

    const groupedRoles: TGroupedRoles = []
    Object.keys(ROLES_BY_GROUPS).forEach((key) => {
      groupedRoles.push({
        label: ROLES_BY_GROUPS[key].label,
        key: String(key),
        options: ROLES_BY_GROUPS[key].roles
          .filter((role) =>
            roles.find((roleToShow) => roleToShow.value === role)
          )
          .map((role) => ({
            // TODO: to change this
            label: ROLES_NAMES[role] ?? ROLES_NAMES[ROLES.VICE_PRESIDENT],
            value: role
          }))
      })
    })
    return [
      {
        label: '',
        key: 'all',
        options: [ALL_ROLES_OPTION]
      },
      ...groupedRoles.filter((group) => !!group.options.length)
    ]
  }, [roles, groupRoles])

  return (
    <div className="user-roles-filter__block">
      <Select
        options={selectOptions}
        propsSelect={{
          onChange,
          defaultValue: ALL_ROLES_OPTION.value
        }}
        className="user-roles-filter"
      />
    </div>
  )
}
